<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7 12L12 17M12 17L17 12M12 17L12 4" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 20H18" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>